import styled, { keyframes } from "styled-components";

const fadeIn = keyframes` from { opacity: 0; } to { opacity: 1; } `;
const slideIn = keyframes` from { transform: translateY(20px); opacity: 0; } to { transform: translateY(0); opacity: 1; } `;
const pulse = keyframes` 0% { box-shadow: 0 0 0 0 rgba(212, 175, 55, 0.4); } 70% { box-shadow: 0 0 0 15px rgba(212, 175, 55, 0); } 100% { box-shadow: 0 0 0 0 rgba(212, 175, 55, 0); } `;

export const WarningOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 8, 20, 0.95);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 11000;
  padding: 15px;
  box-sizing: border-box;
  animation: ${fadeIn} 0.3s ease-in-out;
`;

export const WarningContainer = styled.div`
  background: radial-gradient(circle at top right, #ffffff, #fdfbf0);
  border-radius: 24px;
  border: 1px solid #d4af37;
  padding: 40px;
    box-sizing: border-box;
  max-width: 500px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.3);
  animation: ${slideIn} 0.5s cubic-bezier(0.16, 1, 0.3, 1);

  @media (max-width: 480px) {
    padding: 30px 20px;
      box-sizing: border-box;
    border-radius: 20px;
  }
`;

export const LogosBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  width: 100%;
`;

export const BrandWrapper = styled.div`
  width: 60px;
  height: 60px;
  background: #000;
  border-radius: 12px;
  padding: 8px;
    box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 480px) {
    width: 50px;
    height: 50px;
  }
`;


export const WarningHeader = styled.div`
  margin-bottom: 20px;
`;

export const Badge = styled.span`
  background: #d4af37;
  color: white;
  padding: 4px 12px;
    box-sizing: border-box;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1px;
  margin-bottom: 10px;
  display: inline-block;
`;

export const WarningTitle = styled.h2`
  margin: 10px 0 0;
  font-size: 28px;
  font-weight: 900;
  color: #1a1a1a;
  line-height: 1.2;

  @media (max-width: 480px) {
    font-size: 22px;
  }
`;

export const WarningTextContent = styled.div`
  font-size: 18px;
  line-height: 1.6;
  color: #2d3748;
  margin-bottom: 35px;

  strong {
    color: #b8860b;
    font-weight: 800;
  }

  .footer-text {
    font-size: 14px;
    margin-top: 15px;
    color: #718096;
  }

  @media (max-width: 480px) {
    font-size: 16px;
    margin-bottom: 25px;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export const AcceptButton = styled.button`
  background: linear-gradient(135deg, #d4af37 0%, #b8860b 100%);
  color: white;
  padding: 20px 25px;
    box-sizing: border-box;
  border: none;
  border-radius: 16px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  animation: ${pulse} 2s infinite;

  &:hover {
    transform: translateY(-2px);
    filter: brightness(1.1);
    box-shadow: 0 10px 20px rgba(212, 175, 55, 0.3);
  }

  @media (max-width: 480px) {
    padding: 16px 20px;
      box-sizing: border-box;
    font-size: 15px;
  }
`;

export const CloseButton = styled.button`
  background: transparent;
  color: #718096;
  border: none;
  padding: 10px;
    box-sizing: border-box;

  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: color 0.2s;

  &:hover {
    color: #2d3748;
    text-decoration: underline;
  }
`;
